export enum Permission {
  AdministerLicenseManagement = 'administer_license_management',
  AdministerRolePermissions = 'administer_role_permissions',
  AdministerScenarioDocuments = 'administer_scenario_documents',
  AdministerScenarioReleaseManagement = 'administer_scenario_release_management',
  CreateInstitutions = 'create_institutions',
  CreateReportingCodes = 'create_reporting_codes',
  CreateScenarioPackages = 'create_scenario_packages',
  CreateScenarios = 'create_scenarios',
  CreateUsers = 'create_users',
  DeleteInstitutions = 'delete_institutions',
  DeleteScenarioPackages = 'delete_scenario_packages',
  DeleteScenarios = 'delete_scenarios',
  DeleteUsers = 'delete_users',
  EditInstitutions = 'edit_institutions',
  EditScenarioPackages = 'edit_scenario_packages',
  EditScenarios = 'edit_scenarios',
  EditUsers = 'edit_users',
  ViewAdministration = 'view_administration',
  ViewDownloads = 'view_downloads',
  ViewHelp = 'view_help',
  ViewInstitutions = 'view_institutions',
  ViewLicenseManagement = 'view_license_management',
  ViewReportingCodes = 'view_reporting_codes',
  ViewScenarioPackages = 'view_scenario_packages',
  ViewScenarioReleaseManagement = 'view_scenario_release_management',
  ViewScenarios = 'view_scenarios',
  ViewUsers = 'view_users',
}
